<template>
  <div class="singleChart">

    <TeamRankingChart v-if="(selectedChart ==='teamRanking')"
                      :selectedSubtype="selectedSubtype"
                      :height="getHeight"/>

    <AllCuisinesChart v-else-if="(selectedChart ==='cuisineByRounds')"
                      :selectedTeam="selectedTeam"
                      :height="getHeight"/>

    <CampaignsVsDataChart v-else-if="(selectedChart ==='campaignsVsData')"
                          :selectedRound="selectedRound"
                          :height="getHeight"/>

    <ProductsSoldChart v-else-if="(selectedChart ==='productsSoldByTeams')"
                       :selectedTeam="selectedTeam"
                       :height="getHeight"/>

    <DataBoughtChart v-else-if="(selectedChart ==='dataBoughtByTeams')"
                     :selectedRound="selectedRound"
                     :height="getHeight"/>

    <!--No chart selected -->
    <div v-else-if="selectedChart === null">
      <div style="text-align: center">
        <span>Start with choosing a chart!</span>
      </div>
    </div>
  </div>
</template>

<script>
import TeamRankingChart from "@/components/gameManager/charts/TeamRankingChart";
import AllCuisinesChart from "@/components/gameManager/charts/AllCuisinesChart";
import DataBoughtChart from "@/components/gameManager/charts/DataBoughtChart";
import ProductsSoldChart from "@/components/gameManager/charts/ProductsSoldChart";
import CampaignsVsDataChart from "@/components/gameManager/charts/CampaignsVsDataChart";


export default {
  name: 'ChartSection',
  components: {
    CampaignsVsDataChart,
    ProductsSoldChart,
    TeamRankingChart,
    DataBoughtChart,
    AllCuisinesChart
  },
  props: {
    turn: Number,
    selectedChart: String,
    selectedTeam: Number,
    selectedRound: Number,
    selectedSubtype: String
  },
  computed: {
    getHeight() {
      return document.getElementById("chartSection").offsetHeight - 40;
    }
  },
}
</script>

<style>
</style>
